// extracted by mini-css-extract-plugin
export default {"paragraph":"ParagraphSkeleton_paragraph__RE-9z","slide":"ParagraphSkeleton_slide__Pts0O"};